export default {
  RETIREMENT_INVESTOR_GOAL_REPOSITORY: Symbol.for('RETIREMENT_INVESTOR_GOAL_REPOSITORY'),
  RETIREMENT_INVESTOR_GOAL_COMMAND: Symbol.for('RETIREMENT_INVESTOR_GOAL_COMMAND'),
  CREATE_RETIREMENT_INVESTOR_GOAL_V2_COMMAND: Symbol.for('CREATE_RETIREMENT_INVESTOR_GOAL_V2_COMMAND'),
  GET_RETIREMENT_INVESTOR_GOAL_QUERY: Symbol.for('GET_RETIREMENT_INVESTOR_GOAL_QUERY'),
  RETIREMENT_INVESTOR_GOAL_STATE_MANAGER: Symbol.for('RETIREMENT_INVESTOR_GOAL_STATE_MANAGER'),
  UPDATE_PLAN_RETIREMENT_FUND_INVESTOR_GOAL_COMMAND: Symbol.for('UPDATE_PLAN_RETIREMENT_FUND_INVESTOR_GOAL_COMMAND'),
};
